module.exports = {"pageTitleText":"告警規則","createText":"創建規則","ruleName":"規則名稱","alertRuleQuery":"Query","alertChannelName":"通知對象","alertValue":"告警閥值","alertValueUnit":"閥值單位","isAlerting":"觸發狀態","currentValue":"當前數值","alertMessage":"告警訊息","alertWhen":"高於/低於","alertValueInfo":"告警值","ruleTest":"測試","sections":{"essential":"基礎"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/alertrules.json
// module id = RTiv
// module chunks = 3